import React from 'react';
import PragroupLegal from './PragroupLegal';

const UPDATED = 'Last updated: February 17, 2026';

export default function TermsOfService() {
  return (
    <PragroupLegal badge="Legal" title="Terms of Service" updated={UPDATED}>
      <div className="pg-legal-section">
        <h2>1. Acceptance of Terms</h2>
        <p>By creating an account or using any PRA Group services, you agree to be bound by these Terms of Service (&quot;Terms&quot;). If you do not agree, do not access or use our platform.</p>
        <p>You must be at least 18 years of age (or the legal age of majority in your jurisdiction) to use our services.</p>
      </div>
      <div className="pg-legal-section">
        <h2>2. Account Registration</h2>
        <p>You must provide accurate and complete information during registration. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
        <p>We reserve the right to suspend or terminate accounts that provide false information, engage in fraudulent activity, or violate these Terms.</p>
      </div>
      <div className="pg-legal-section">
        <h2>3. Services Provided</h2>
        <p>PRA Group provides a cryptocurrency wallet platform enabling users to store, send, receive, stake, and exchange digital assets. We are a technology provider — not a financial advisor, broker, or custodian of your assets.</p>
        <p>Availability of specific tokens, staking options, and exchange pairs may vary by region and are subject to change without notice.</p>
      </div>
      <div className="pg-legal-section">
        <h2>4. Fees &amp; Charges</h2>
        <p>Certain services may be subject to fees, including transaction fees, network (gas) fees, and exchange spreads. All applicable fees are disclosed before you confirm a transaction.</p>
        <p>Network fees are determined by the underlying blockchain and are outside our control.</p>
      </div>
      <div className="pg-legal-section">
        <h2>5. Prohibited Activities</h2>
        <p>You agree not to use PRA Group for money laundering, terrorist financing, or any illegal activity; market manipulation or fraudulent trading; circumventing sanctions or export controls; distributing malware, unauthorized access attempts, or interference with our systems; or creating multiple accounts for abusive purposes.</p>
      </div>
      <div className="pg-legal-section">
        <h2>6. Risk Disclosure</h2>
        <p>Cryptocurrency markets are highly volatile. The value of digital assets can fluctuate significantly in short periods. You acknowledge that you may lose some or all of your investment.</p>
        <p>PRA Group does not provide investment advice. All trading and staking decisions are your sole responsibility.</p>
      </div>
      <div className="pg-legal-section">
        <h2>7. Intellectual Property</h2>
        <p>All content, trademarks, logos, software, and design elements on the PRA Group platform are owned by or licensed to us. You may not reproduce, modify, distribute, or create derivative works without our express written permission.</p>
      </div>
      <div className="pg-legal-section">
        <h2>8. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, PRA Group shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or digital assets.</p>
        <p>Our total liability for any claim shall not exceed the amount of fees you paid to us in the 12 months preceding the claim.</p>
      </div>
      <div className="pg-legal-section">
        <h2>9. Dispute Resolution</h2>
        <p>Any disputes arising from these Terms shall be resolved through binding arbitration in accordance with the rules of the applicable arbitration body in the jurisdiction of our registered office, unless prohibited by local law.</p>
        <p>You agree to waive any right to participate in class action lawsuits or class-wide arbitration, to the extent permissible by law.</p>
      </div>
      <div className="pg-legal-section">
        <h2>10. Modifications</h2>
        <p>We may modify these Terms at any time. Material changes will be communicated at least 14 days before taking effect. Continued use after the effective date constitutes acceptance.</p>
      </div>
      <div className="pg-legal-section">
        <h2>11. Contact</h2>
        <p>For questions about these Terms, contact us at <strong>legal@cryptovault.exchange</strong>.</p>
      </div>
    </PragroupLegal>
  );
}
